import React, { useState } from "react";
import routes from "../../SideBarRoutes";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Link, Route } from "react-router-dom";
import SidebarSubmenu from "./SidebarSubmenu";
import DropDown from "../Helper/DropDown";
import { logout } from "../../redux/UserReducer";
import { API_URL } from "../../redux/constants";

export default function SidebarContent() {
  const user = useSelector((state) => state.user.user);
  const [profileExpanded, setProfileExpanded] = useState(false);
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col gap-x-4 py-4 pl-4 h-screen shadow-md">
      <span className="p-2 flex justify-between">
        <Link
          className="text-2xl font-bold text-gray-800 dark:text-gray-200"
          to="/dashboard"
        >
          Wellm8
        </Link>
        <DropDown
          _handleSelected={(e) => {
            dispatch(logout());
          }}
          items={["Log Out"]}
          menuButton={
            <img
              src={API_URL + "/image/profile/" + user._id}
              className="flex relative h-8 w-8 object-cover rounded-full"
              onClick={() => setProfileExpanded(!profileExpanded)}
            />
          }
        />
      </span>
      <ul className="mt-6">
        {routes.map((route) =>
          route.routes ? (
            <SidebarSubmenu route={route} key={route.name} />
          ) : (
            <li className="relative px-6 py-3" key={route.name}>
              <NavLink
                exact
                to={route.path}
                className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
                activeClassName="text-gray-800 dark:text-gray-100"
              >
                <Route path={route.path} exact={route.exact}>
                  <span
                    className="absolute inset-y-0 left-0 w-1 bg-purple-600 rounded-tr-lg rounded-br-lg"
                    aria-hidden="true"
                  ></span>
                </Route>
                <span className="ml-4">{route.name}</span>
              </NavLink>
            </li>
          )
        )}
      </ul>
    </div>
  );
}
